// TODO (kyle): this is a dead file. find all references to its state and remove them!

// @ts-nocheck

import type {
  Contact,
  ContactList,
  EditingContactList,
} from 'src/types/contacts';


export type State = {
  editing: EditingContactList | null | undefined;
  adding:
    | {
        contact: Contact;
        errors?: Record<any, any>;
      }
    | null
    | undefined;
  lists: {
    [listId: string]: ContactList;
  };
};

export default (
  state: State | null | undefined = {
    editing: null,
    adding: null,
    lists: {},
  },
  action: ContactListAction,
) => state;
